import './App.css';
import router from './router';

import {
  RouterProvider,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from 'react-query'
// import SettingsProvider from './Context/settingsProvider';
import AppProvider from './Context/appProvider';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
        <AppProvider>
          <RouterProvider router={router} />
          <ToastContainer />
        </AppProvider>
      </QueryClientProvider>
  );
}

export default App;